import {
  StyledReportCellRow,
  StyledReportParagraph,
} from "components/report/ReportCell/styled";
import React from "react";

type ReportCellProps = {
  label: string;
  text: string;
} & StyledReportParagraph;
export const ReportCell: React.FC<ReportCellProps> = ({
  label,
  text,
  ...rest
}) => {
  const replaced = text.replaceAll(/¥n/g, "\\n");
  const splited = replaced.split("\\n");
  const newLlined = splited.reduce((current, next) => `${current}\n${next}`);
  return (
    <>
      <StyledReportCellRow>
        <StyledReportParagraph
          className="cell-label"
          fontWeight="600"
          {...rest}
        >
          {label}
        </StyledReportParagraph>
        <StyledReportParagraph fontWeight="400" {...rest}>
          {newLlined}
        </StyledReportParagraph>
      </StyledReportCellRow>
    </>
  );
};
